import React from "react";
import "./termsPage.scss";
import "../../utils/Styles/globalclasses.scss";

import Hero from "./components/hero/Hero";
import TermsCondition from "./components/termsCondition/TermsCondition";
import Footer from "../../components/footer/Footer";

const TermsPage = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  return (
    <div>
      <Hero
        text={"Terms and Conditions"}
        // date={"Last Updated October 7, 2020"}
      />
      <TermsCondition />
      <Footer />
    </div>
  );
};

export default TermsPage;
